import { createEffectGlobalPresetExport } from './effectPresets'

const staticControls = (values = {}) => ({
  values,
  auto: Object.keys(values).reduce((acc, key) => {
    acc[key] = 'none'
    return acc
  }, {}),
  mod: {},
})

export const GLOBAL_EFFECT_PRESETS = [
  createEffectGlobalPresetExport({
    id: 'effects.soft_bloom',
    name: 'Soft Bloom',
    group: 'postprocessing',
    description: 'Gentle bloom lift for highlights.',
    intentTags: ['soft glow', 'bloom', 'cinematic glow', 'gentle glow'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'ubloom',
      controls: staticControls({
        strength: 0.75,
        radius: 0.32,
        threshold: 0.18,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.strong_bloom',
    name: 'Strong Bloom',
    group: 'postprocessing',
    description: 'A stronger glow treatment for bright visual moments.',
    intentTags: ['strong glow', 'bright bloom', 'neon glow'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'ubloom',
      controls: staticControls({
        strength: 1.45,
        radius: 0.42,
        threshold: 0.08,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.subtle_grain',
    name: 'Subtle Grain',
    group: 'postprocessing',
    description: 'Light film grain texture.',
    intentTags: ['grain', 'film grain', 'texture', 'analog'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'grain',
      controls: staticControls({
        opacity: 0.035,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.heavy_grain',
    name: 'Heavy Grain',
    group: 'postprocessing',
    description: 'Obvious rough film grain.',
    intentTags: ['heavy grain', 'gritty', 'rough texture'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'grain',
      controls: staticControls({
        opacity: 0.12,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.soft_vignette',
    name: 'Soft Vignette',
    group: 'postprocessing',
    description: 'Subtle edge darkening for focus.',
    intentTags: ['vignette', 'edge darken', 'cinematic frame'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'vignette',
      controls: staticControls({
        offset: 0.38,
        darkness: 0.28,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.high_contrast',
    name: 'High Contrast',
    group: 'postprocessing',
    description: 'Punchier contrast with a slight saturation lift.',
    intentTags: ['high contrast', 'punchy', 'bold color', 'color adjust'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'colorAdjust',
      controls: staticControls({
        brightness: 0,
        contrast: 0.32,
        saturation: 0.18,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.desaturated',
    name: 'Desaturated',
    group: 'postprocessing',
    description: 'Muted low-saturation look.',
    intentTags: ['desaturate', 'muted color', 'washed out'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'colorAdjust',
      controls: staticControls({
        brightness: 0,
        contrast: 0.08,
        saturation: -0.55,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.pixel_pop',
    name: 'Pixel Pop',
    group: 'postprocessing',
    description: 'Blocky pixelated texture with edge emphasis.',
    intentTags: ['pixelate', 'blocky', '8-bit', 'pixel pop'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'pixelate',
      controls: staticControls({
        pixelSize: 8,
        edgeNormalStrength: 0.45,
        edgeDepthStrength: 0.45,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.glitch_hit',
    name: 'Glitch Hit',
    group: 'postprocessing',
    description: 'Sharp glitch burst foundation.',
    intentTags: ['glitch', 'glitch hit', 'digital glitch'],
    preset: {
      code: 'postprocessing',
      power: 100,
      math: 'glitch',
      controls: staticControls({
        dt_size: 96,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.soft_focus_blur',
    name: 'Soft Focus Blur',
    group: 'blur',
    description: 'Soft global blur for gentle focus pulls.',
    intentTags: ['soft blur', 'focus blur', 'dreamy blur'],
    preset: {
      code: 'blur',
      power: 100,
      controls: staticControls({
        intensity: 0.28,
        radius: 2.4,
      }),
      tweens: {},
    },
  }),
  createEffectGlobalPresetExport({
    id: 'effects.heavy_blur',
    name: 'Heavy Blur',
    group: 'blur',
    description: 'Strong blur wash.',
    intentTags: ['heavy blur', 'blur out', 'wash blur'],
    preset: {
      code: 'blur',
      power: 100,
      controls: staticControls({
        intensity: 0.82,
        radius: 7,
      }),
      tweens: {},
    },
  }),
].filter(Boolean)

export default GLOBAL_EFFECT_PRESETS
